import  { CARGAR_PROVEEDOR } from './actionTypes';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';
import { VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_proveedor = (codigo) => {
    return (dispatch) => {
        var proveedor;
        let config_request = {
            method: 'GET',
            url: '/proveedores/'+codigo,
        }
		
		return global_axios(config_request)
        .then( response => {
            proveedor=response.data;

            let config_req_pais = {
                method: 'GET',
                url: '/catalogos?tipo=tabla&opcion=PAIS&cadena_busq=' + proveedor.pais
            }
            return global_axios(config_req_pais)
            .then( response => {
                proveedor.pais = selectorcatalogos(proveedor.pais ,response.data);

                let config_req_ciudad = {
                    method: 'GET',
                    url: '/catalogos?tipo=tabla&opcion=CIUDAD&cadena_busq=' + proveedor.ciudad
                }

                return global_axios(config_req_ciudad)
                .then( response => {
                    proveedor.ciudad = selectorcatalogos(proveedor.ciudad ,response.data);

                    let config_req_anticipo = {
                        method: 'GET',
                        url: '/cuentas?cadena_busq=' + proveedor.cta_anticipo
                    }
    
                    return global_axios(config_req_anticipo)
                    .then( response => {
                        proveedor.cta_anticipo = selectorcatalogos(proveedor.cta_anticipo ,response.data);

                        let config_req_contable = {
                            method: 'GET',
                            url: '/cuentas?cadena_busq=' + proveedor.cta_contable
                        }
        
                        return global_axios(config_req_contable)
                        .then( response => {
                            proveedor.cta_contable = selectorcatalogos(proveedor.cta_contable ,response.data);
                            
                            let config_req_cta_contable_servicio = {
                                method: 'GET',
                                url: '/cuentas?cadena_busq=' + proveedor.cta_servicio
                            }
                            return global_axios(config_req_cta_contable_servicio)
                            .then( response => {
                                proveedor.cta_servicio = selectorcatalogos(proveedor.cta_servicio ,response.data);
                                let config_req_rubro_imp = {
                                    method: 'GET',
                                    url: '/catalogos?tipo=tabla&opcion=Retencion&cadena_busq='+proveedor.rubro_imp
                                }
                
                                return global_axios(config_req_rubro_imp)
                                .then( response => {
                                    proveedor.rubro_imp = selectorcatalogos(proveedor.rubro_imp ,response.data);
    
                                    let config_req_banco = {
                                        method: 'GET',
                                        url: '/catalogos?tipo=tabla&opcion=BANCO&cadena_busq='+proveedor.Banco
                                    }
    
                                    return global_axios(config_req_banco)
                                    .then( response => {
                                        proveedor.Banco = selectorcatalogos(proveedor.Banco ,response.data);
    
                                        dispatch({
                                            type: CARGAR_PROVEEDOR,
                                            data: proveedor,    
                                        }); 
                                    })
                                    .catch(error=>{
                                        let msgError = error.response?error.response.data.msg:error.message;                                
                                        dispatch({
                                            type: VISUALIZAR_ALERTA,
                                            data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                                        });
                                    });
                                })
                                .catch(error=>{
                                    let msgError = error.response?error.response.data.msg:error.message;                                
                                    dispatch({
                                        type: VISUALIZAR_ALERTA,
                                        data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                                    });
                                });
                            }).catch(error=>{
                                let msgError = error.response?error.response.data.msg:error.message;                                
                                dispatch({
                                    type: VISUALIZAR_ALERTA,
                                    data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                                });
                            });
                        })
                        .catch(error=>{
                            let msgError = error.response?error.response.data.msg:error.message;                                
                            dispatch({
                                type: VISUALIZAR_ALERTA,
                                data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                            });
                        });
                    })
                    .catch(error=>{
                        let msgError = error.response?error.response.data.msg:error.message;                                
                        dispatch({
                            type: VISUALIZAR_ALERTA,
                            data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                        });
                    });
                })
                .catch(error=>{
                    let msgError = error.response?error.response.data.msg:error.message;                                
                    dispatch({
                        type: VISUALIZAR_ALERTA,
                        data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                    });
                });
            })
            .catch(error=>{
                let msgError = error.response?error.response.data.msg:error.message;                                
                dispatch({
                    type: VISUALIZAR_ALERTA,
                    data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
                });
            });
        })
        .catch(error=>{
            let msgError = error.response?error.response.data.msg:error.message;                                
            dispatch({
                type: VISUALIZAR_ALERTA,
                data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar proveedor', mensaje: msgError}
            });
        });
    }
}

export const cargar_ValoresIniciales = () => {
	return (dispatch) => {					
        
		dispatch({
			type: INICIALIZAR_FORM,
            data: {	contr_esp: "N",
                    proveedor_obra: "N",
                    relacionada: "NO",
                    tipo_empresa: "P",
                    tipo_proveedor:"B",
                    tipo_persona: "N", 
                    extranjero: "N"
                }			
		})
	}
};

function selectorcatalogos(clave , array){
    var result = {};
    for(var i = 0; i<array.length; i++){
        if(array[i].Codigo === clave){
            result = { value: array[i].Codigo, label: array[i].Descripcion+` (${array[i].Codigo})`}
            break;
        }
    }
    return result;
}